import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20deep%20crimson%20and%20warm%20golden%20amber%20tones%2C%20flowing%20ink%20wash%20texture%2C%20japanese%20aesthetic%20composition%2C%20soft%20atmospheric%20feel%2C%20elegant%20modern%20design%2C%20no%20text%2C%20no%20people&width=1920&height=600&seq=cta-jmtt-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始探索了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
          加入数百万用户的行列，在禁漫天堂发现属于你的漫画世界。新用户注册即享专属福利。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/hot"
            className="px-7 py-3 rounded-md bg-primary-500 text-white text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-md bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm md:text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}